import type {} from '@mui/x-date-pickers/themeAugmentation';
import type { Theme, ThemeOptions } from '@mui/material/styles';

/** Calendar popup RTL styling (field chrome lives in Input.theme / SmPickerField). */
export function datePickerThemeComponents(theme: Theme): ThemeOptions['components'] {
  return {
    MuiPickersCalendarHeader: {
      styleOverrides: {
        root: {
          paddingLeft: '32px',
          paddingRight: '20px',
          '& .MuiPickersCalendarHeader-label': {
            fontWeight: 400
          },
          '& .MuiPickersCalendarHeader-switchViewButton': {
            display: 'none'
          }
        }
      }
    },
    MuiPickersPopper: {
      styleOverrides: {
        paper: {
          backgroundColor: theme.palette.background.paper
        }
      }
    }
  };
}
